module.exports = __webpack_public_path__ + "static/media/varie8.9bda8141.jpg";